"use client";

import React from "react";
import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
interface FaqItem {
  id: string;
  question: string;
  answer: string;
}
const faqs: FaqItem[] = [{
  id: "item-1",
  question: "Wie buche ich ein Taxi in Hurghada?",
  answer: "Sie können Ihr privates Taxi ganz einfach über unseren WhatsApp-Service oder online buchen. Teilen Sie uns einfach Ihren Abholort, Ihr Ziel und Ihre gewünschte Abholzeit mit. Wir bestätigen Ihre Fahrt vor der Abfahrt mit einem garantierten Festpreis."
}, {
  id: "item-2",
  question: "Kann ich ein Taxi von meinem Hotel aus buchen?",
  answer: "Ja. Unsere Fahrer holen Sie direkt an Ihrer Resort-Lobby oder am Sicherheitstor in allen Stadtteilen und Hotelanlagen von Hurghada ab. Die Fahrzeugdaten Ihres Fahrers erhalten Sie vorab für eine reibungslose Abstimmung."
}, {
  id: "item-3",
  question: "Bieten Sie auch Rückfahrten an?",
  answer: "Ja, Rückfahrten lassen sich problemlos organisieren. Sie können eine feste Rückfahrtzeit im Voraus vereinbaren oder Ihrem Fahrer per WhatsApp schreiben, sobald Sie bereit für die Rückfahrt zu Ihrem Hotel oder Resort sind."
}, {
  id: "item-4",
  question: "Kann ich ein Taxi zwischen verschiedenen Ferienorten buchen?",
  answer: "Ja. Wir bieten private Direkttransfers zwischen allen Ferienorten am Roten Meer an, darunter Hurghada Stadt, El Gouna, Makadi Bay, Sahl Hasheesh und Soma Bay – zu festen, transparenten Preisen."
}, {
  id: "item-5",
  question: "Kann ich ein Taxi für Einkäufe oder einen Restaurantbesuch buchen?",
  answer: "Ja. Unsere Privatfahrten eignen sich ideal für Restaurantbesuche an der Hurghada Marina, Ausflüge zu lokalen Basaren, Einkaufszentren oder Sehenswürdigkeiten – mit komfortablem Tür-zu-Tür-Service."
}, {
  id: "item-6",
  question: "Wie werden die Taxipreise bestätigt?",
  answer: "Alle Fahrpreise werden vor Fahrtantritt verbindlich vereinbart. Sie erhalten einen garantierten Festpreis ohne Taxameter-Diskussionen oder Preissprünge. Die Bezahlung erfolgt bequem bei Ankunft an Ihrem Zielort."
}, {
  id: "item-7",
  question: "Kann ich über WhatsApp buchen?",
  answer: "Ja. Unser WhatsApp-Kundenservice steht Ihnen rund um die Uhr zur Verfügung, um Buchungen zu bestätigen, Fragen zu Routen zu beantworten und Ihre Fahrerdetails direkt abzustimmen."
}, {
  id: "item-8",
  question: "Was ist der Unterschied zwischen lokalem Taxiservice und Flughafentransfer?",
  answer: "Unser lokaler Taxiservice ist ideal für spontane Stadtfahrten, Transfers zwischen Ferienorten, Restaurant- und Shoppingausflüge. Spezielle Flughafenankunftstransfers mit persönlicher Begrüßung am Terminal können Sie auf unserer Seite 'Transfer buchen' reservieren."
}, {
  id: "item-9",
  question: "Was passiert bei Flugverspätungen bei einer Flughafenabholung?",
  answer: "Wir verfolgen die Ankunftszeit und mögliche Verspätungen deines Fluges kostenlos. Dein Transfer beinhaltet bis zu 60 Minuten kostenlose Wartezeit ab dem vereinbarten Treffzeitpunkt."
}];
export default function TaxiFaqs() {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map(faq => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer
      }
    }))
  };
  return <section id="taxiservicefaqs" data-nav="light" className="bg-background text-foreground py-16 md:py-20">
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(faqSchema)
    }} />

      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-10 md:mb-12">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-accent-foreground font-default">
            Häufig gestellte Fragen zum Taxiservice
          </h2>
        </motion.div>

        <div className="bg-card border border-border rounded-xl shadow-xs p-6 md:p-8">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => <AccordionItem key={faq.id} value={faq.id} data-index={index} className="border-border border-b last:border-b-0 py-1">
                <AccordionTrigger className="text-left font-semibold text-accent-foreground hover:no-underline text-base md:text-lg [&>svg]:text-primary [&>svg]:size-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-sm md:text-base leading-relaxed pt-1 pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}